export default __webpack_public_path__ + "static/media/28.70fbbd79.png";